import MaterialTextEditor from './MaterialTextEditor';

export default MaterialTextEditor;
